import type { DownloadTreeNode } from '~/types/download'
import type { AcademicArticleSection } from '~/utils/solr/academic-article'
import type { BookAndArticle } from '~/utils/solr/literature'

interface MapAcademicArticleTocToDownloadNodesParams {
  sections?: AcademicArticleSection[] | null
  article?: BookAndArticle | null
}

export function mapAcademicArticleTocToDownloadNodes({ sections, article }: MapAcademicArticleTocToDownloadNodesParams): DownloadTreeNode[] {
  if (!sections?.length || !article?.id) {
    return []
  }

  const authors = article.authorName ?? article.author ?? null
  const subtitle = article.subtitle ?? null
  const lastUpdated = article.lastUpdatedByEditor ?? article.timestamp ?? null

  return sections.map((section, tocIndex) => ({
    id: section.id,
    downloadId: section.id,
    title: section.title || `Del ${tocIndex + 1}`,
    nodeType: 'academic_article_section',
    type: 'academic_article_section',
    bodytext: section.bodytext ?? null,
    source: article.title ?? null,
    authors: authors ?? undefined,
    lastUpdated,
    tocIndex,
    selectable: true,
    payload: {
      kind: 'academic_article',
      articleId: article.id,
      articleTitle: article.title ?? 'Fagartikkel',
      articleSubtitle: subtitle,
      articleLastChanged: lastUpdated,
      authors,
      sectionTitle: section.title ?? null,
    },
  }))
}
